module.exports = __webpack_public_path__ + "img/menu_wallet.6f45b6d6.svg";